"use strict";
/**
 * @module Services.TopicUpdate
 */
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.GetTopicViewResultSerialiser = exports.GetTopicViewResultSerialiserClass = void 0;
var Codec = require("./../../io/codec");
var serialiser_1 = require("./../../serialisers/serialiser");
var get_topic_view_result_1 = require("./get-topic-view-result");
var read_topic_view_1 = require("./read-topic-view");
/**
 * Serialiser for {@link GetTopicViewResult}
 */
var GetTopicViewResultSerialiserClass = /** @class */ (function (_super) {
    __extends(GetTopicViewResultSerialiserClass, _super);
    function GetTopicViewResultSerialiserClass() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * Read a {@link GetTopicViewResult} from the stream
     *
     * @param bis  the input stream
     * @return     the {@link GetTopicViewResult} that was read
     */
    GetTopicViewResultSerialiserClass.prototype.read = function (bis) {
        var option = Codec.readByte(bis);
        var result = (option === 1) ? read_topic_view_1.readTopicView(bis) : null;
        return new get_topic_view_result_1.GetTopicViewResult(result);
    };
    return GetTopicViewResultSerialiserClass;
}(serialiser_1.AbstractSerialiser));
exports.GetTopicViewResultSerialiserClass = GetTopicViewResultSerialiserClass;
/**
 * The {@link GetTopicViewResultSerialiser} singleton
 */ // eslint-disable-next-line @typescript-eslint/naming-convention
exports.GetTopicViewResultSerialiser = new GetTopicViewResultSerialiserClass();
